module.exports = __webpack_public_path__ + "static/media/map.56ce220c.png";